import {React, useState} from 'react';
import Header from '../../Layout/Header';
import NonCarouselBanner from '../../UI/Banner/NonCarouselBanner';
import Footer from '../../Layout/Footer';
import hospitalImage from "../../assets/Images/Global/membership-banner.jpg";
import Resuableform from '../../FeatureComponent/Healthcardform/Resuableform';
import OtpModal from '../../UI/UIComponent/Modal/OtpModal';





export default function Healthcardpage() {
    const [patientPayload,setpatientPayload] = useState({});
      const [encodedData, setEncodeddata] = useState();
      const handleCallback = (childData) =>{
        setpatientPayload({...childData});
        setEncodeddata(childData.encodedData)
      }
  return (
    <>
      
      {/* <OtpModal patientInfoPayload = {patientPayload} patientEncodedData = {encodedData}></OtpModal> */}
      <Header></Header>
      <OtpModal patientInfoPayload = {patientPayload} patientEncodedData = {encodedData}></OtpModal>
      <section className='hospital-landing-page'>
        <NonCarouselBanner
          ImageSrc={hospitalImage}
          imageAlt="RHS Hospital Addmission"
          heading = "The Rever Health Solution"
          Subheading= "Consult Our Trusted Surgeons, Book an Appointment"
          footNote = "The best of modern healthcare to ensure you stay healthy, always."
        ></NonCarouselBanner>
        <Resuableform parentCallback={handleCallback}></Resuableform>
        <Footer></Footer>
      </section>
    </>
  )
}
